import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, setFormError } from '../../../utils/utils';
import { createUser, editUserById, loadUserList } from '../actions';
import Loader from '../../../components/base/Loader/Loader';
import { getUserData } from '../reducer';
import UserDTO from '../../../dto/UserDTO';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { ROLE_TYPE_LIST } from '../../../configs';
import Switches from '../../../components/fields/Switches/Switches';

export default function UserForm(props) {
  const {
    onCancel = () => {},
    onClose = () => {},
    loadData = () => {},
    loadUser = () => {},
    currentUser = null,
  } = props;
  const { loadingCreateUser, loadingEditUserById } = useSelector(getUserData);
  const dispatch = useDispatch();
  const [defs, setDefs] = useState(currentUser ? { ...currentUser } : {});
  const {
    reset, control, getValues, setError,
  } = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  useEffect(() => {
    // avoid mutating Redux state by working with a shallow copy
    setDefs(currentUser ? { ...currentUser } : {});
    // reset form values from copied defs
    reset(currentUser ? { ...currentUser } : {});
  }, [currentUser]);

  const handleSave = () => {
    const values = getValues();
    const action = currentUser?.id ? editUserById({ ...values, id: currentUser.id }) : createUser(values);
    dispatch(action)
      .then(user => {
        successNotification('Сохранение формы', 'Форма сохранена');
        loadData();
        loadUser(user.id);
        onClose();
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы', getResponseError(response));
      });
  };

  React.useEffect(() => {
    // ensure form is synced with defs when defs changes
    reset(defs || {});
  }, [defs]);

  const dto = new UserDTO();
  const attributes = dto.getAttributesByName();

  return ReactDOM.createPortal(
    <div className="form-dialog user-form">
      <Loader loading={loadingCreateUser || loadingEditUserById} />
      <div className="form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Пользователи</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Пользователь № {currentUser?.id || 'Без номера'}</span>
          <span className="breadcrumbs-current"> ({currentUser?.id ? 'редактирование' : 'создание'}) </span>

        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="form-body">
        <form className="form-content">
          <div className="form-fields">
            <div className="form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main user-main-info">
                  <div className="f4">Основная информация</div>
                  <Row>
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.username}
                      variant="material"
                      withLabel
                    />
                  </Row>
                  <Row>
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.full_name}
                      variant="material"
                      withLabel
                    />
                  </Row>
                  <Row>
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={TextInputWithLabel}
                      dtoObject={attributes.password}
                      variant="material"
                      withLabel
                    />
                  </Row>
                  {/* <Row> */}
                  {/*  <FieldDTOWithCol */}
                  {/*    control={control} */}
                  {/*    type="text" */}
                  {/*    component={TextInputWithLabel} */}
                  {/*    dtoObject={attributes.tg_id} */}
                  {/*    variant="material" */}
                  {/*    withLabel */}
                  {/*  /> */}
                  {/* </Row> */}
                  {/* <Row> */}
                  {/*  <FieldDTOWithCol */}
                  {/*    control={control} */}
                  {/*    type="text" */}
                  {/*    component={TextInputWithLabel} */}
                  {/*    dtoObject={attributes.tg_username} */}
                  {/*    variant="material" */}
                  {/*    withLabel */}
                  {/*  /> */}
                  {/* </Row> */}
                  <Row>
                    <FieldDTOWithCol
                      control={control}
                      type="text"
                      component={CustomSelectInput}
                      dtoObject={attributes.role}
                      variant="material"
                      withLabel
                      options={ROLE_TYPE_LIST}
                    />
                  </Row>
                  {currentUser?.id ? (
                    <Row>
                      <FieldDTOWithCol
                        control={control}
                        type="text"
                        component={Switches}
                        dtoObject={attributes.is_active}
                        variant="material"
                        withLabel
                      />
                    </Row>
                  ) : null}
                </div>
                <div className="afc-add" />
              </div>
            </div>
          </div>
          <div className="form-footer">
            <Button onClick={() => handleSave()}>{currentUser?.id ? 'Сохранить' : 'Создать'}</Button>
            <Button variant="secondary" onClick={onClose}>Отменить</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
